module.exports = __webpack_public_path__ + "static/media/7.4d0a289c.jpg";